(function () {
  if (window.musayoCodeBound) return;
  window.musayoCodeBound = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function show(form, text) {
    var status = form.querySelector('[data-musayo-code-status]');
    if (!status) return;
    status.hidden = false;
    status.textContent = text;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-musayo-code-form]');
    if (!form) return;
    event.preventDefault();

    var input = form.querySelector('input[name="code"]');
    var button = form.querySelector('button[type="submit"]');
    var code = (input.value || '').trim();
    if (!code) return;

    button.disabled = true;

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var codes = (cart.discount_codes || [])
          .filter(function (entry) {
            return entry.applicable;
          })
          .map(function (entry) {
            return entry.code;
          });
        var known = codes.some(function (existing) {
          return existing.toLowerCase() === code.toLowerCase();
        });
        if (!known) codes.push(code);
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') }),
        }).then(function (response) {
          return response.json();
        });
      })
      .then(function (cart) {
        var match = (cart.discount_codes || []).find(function (entry) {
          return entry.code.toLowerCase() === code.toLowerCase();
        });
        if (match && match.applicable) {
          window.location.assign(root + 'cart');
          return;
        }
        var keep = (cart.discount_codes || [])
          .filter(function (entry) {
            return entry.applicable && entry.code.toLowerCase() !== code.toLowerCase();
          })
          .map(function (entry) {
            return entry.code;
          });
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: keep.join(',') }),
        }).then(function () {
          show(form, form.getAttribute('data-invalid'));
          button.disabled = false;
          input.focus();
        });
      })
      .catch(function () {
        show(form, form.getAttribute('data-error'));
        button.disabled = false;
      });
  });
})();
